import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["thresholdOption", "thresholdCheck", "customInput", "customRadio", "contextValue", "contextSlider", "enabledToggle"]

  connect() {
    this.initializeCustomValue()
    this.setupRadioListeners()
  }

  initializeCustomValue() {
    const currentValue = parseInt(this.data.get("currentValue"))
    const presetValues = [24, 48, 72, 96, 120, 168]

    if (!presetValues.includes(currentValue) && this.hasCustomInputTarget) {
      this.customInputTarget.value = currentValue
    }
  }

  setupRadioListeners() {
    const radios = this.element.querySelectorAll('input[name="nudge_configuration[inactivity_threshold_hours]"]')
    radios.forEach(radio => {
      radio.addEventListener('change', () => this.updateThresholdStyles())
    })
  }

  toggleEnable(event) {
    // Auto-submit only for the enable/disable toggle
    event.target.form.requestSubmit()
  }

  selectThreshold(event) {
    const radio = event.currentTarget.querySelector('input[type="radio"]')
    if (radio) {
      radio.checked = true
      this.updateThresholdStyles()
    }
  }

  updateThresholdStyles() {
    // Reset all options to default state
    this.thresholdOptionTargets.forEach((option) => {
      const label = option.querySelector('label')
      const check = option.querySelector('.threshold-check')
      const title = option.querySelector('span.font-semibold')
      const subtitle = option.querySelector('span.text-xs')

      // Remove selected styles
      if (label) {
        label.classList.remove('border-indigo-600', 'bg-indigo-50')
        label.classList.add('border-gray-200', 'bg-white')
      }
      if (check) check.classList.add('hidden')
      if (title) {
        title.classList.remove('text-indigo-900')
        title.classList.add('text-gray-900')
      }
      if (subtitle) {
        subtitle.classList.remove('text-indigo-700')
        subtitle.classList.add('text-gray-500')
      }
    })

    // Find and style the selected option
    const checkedRadio = this.element.querySelector('input[name="nudge_configuration[inactivity_threshold_hours]"]:checked')
    if (checkedRadio && checkedRadio.parentElement) {
      const label = checkedRadio.parentElement.querySelector('label')
      const check = checkedRadio.parentElement.querySelector('.threshold-check')
      const title = checkedRadio.parentElement.querySelector('span.font-semibold')
      const subtitle = checkedRadio.parentElement.querySelector('span.text-xs')

      // Add selected styles
      if (label) {
        label.classList.remove('border-gray-200', 'bg-white')
        label.classList.add('border-indigo-600', 'bg-indigo-50')
      }
      if (check) check.classList.remove('hidden')
      if (title) {
        title.classList.remove('text-gray-900')
        title.classList.add('text-indigo-900')
      }
      if (subtitle) {
        subtitle.classList.remove('text-gray-500')
        subtitle.classList.add('text-indigo-700')
      }
    }
  }

  updateCustomValue(event) {
    const value = event.target.value
    if (this.hasCustomRadioTarget) {
      this.customRadioTarget.value = value
      this.customRadioTarget.checked = true
      this.updateThresholdStyles()
    }
  }

  updateContextValue(event) {
    if (this.hasContextValueTarget) {
      this.contextValueTarget.textContent = `${event.target.value} messages`
    }
  }
}